import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchThreatMonitoringEvents, setThreatEventStatus } from '../../services/api/threatMonitoringService';

export const loadThreatMonitoring = createAsyncThunk('threatMonitoring/load', async () => fetchThreatMonitoringEvents());

export const changeThreatEventStatus = createAsyncThunk(
  'threatMonitoring/changeStatus',
  async ({ id, status }) => setThreatEventStatus(id, status)
);

const threatMonitoringSlice = createSlice({
  name: 'threatMonitoring',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadThreatMonitoring.pending, (state) => { state.status = 'loading'; })
      .addCase(loadThreatMonitoring.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadThreatMonitoring.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(changeThreatEventStatus.fulfilled, (state, action) => {
        const item = state.items.find((e) => e.id === action.payload.id);
        if (item) item.status = action.payload.status;
      });
  }
});

export default threatMonitoringSlice.reducer;
